import {TransportCategory, TransportGaugeType, transportGaugeTypes} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";
import {useMemo} from "react";

type Props = DbCodeSelectProps<TransportGaugeType> & {
  selector?: {
    category?: TransportCategory
  }
}

export const TransportGaugeTypeSelect = (props: Props) => {
  const {
    options: defaultOptions = transportGaugeTypes,
    selector,
    ...rest
  } = props;

  const options = useMemo(() => {
    const types: TransportGaugeType[] = []
    if (selector && selector.category) {
      for (const option of defaultOptions) {
        if (!option.categoryRestriction || option.categoryRestriction === selector.category) {
          types.push(option)
        }
      }
    } else {
      types.push(...defaultOptions)
    }
    return types
  }, [defaultOptions, selector])


  return <BaseDbCodeSelect options={options} {...rest} />;
};
